module.exports = __webpack_public_path__ + "media/joanna_5m.5cfc1abc.mp3";